import http from './request'

export async function submitMessage(payload){
    return await http.post('/message',payload)
}

export async function getMessage(params){
    return await http.get('/message',{params})
}